<template>
  <div>
    <slot :record="data_provider_ref[type]" :dataprovider="data_provider_ref"></slot>
  </div>
</template>

<script>
export default {
  name: 'data-form-header',
  props: {},
  watch: {},
  computed: {
    data_provider_ref() {
      return this.$parent.data_provider_ref;
    },
    type() {
      return this.$parent.type;
    },
  },
  mounted() {},
  data() {
    return {}
  }
}
</script>
